import React, { PropTypes } from 'react';
import RenderField from '../../../FormTemplate/InputControl';
import { Field } from 'redux-form';
import { Table } from 'react-bootstrap';

class RenderLists extends React.Component {

   componentDidMount() {
      this.props.items.forEach((item) => {
         this.props.fields.push({
            id: item.id,
            item_id: item.item_id,
            name: item.name,
            price: item.price,
            unit: item.unit,
         });
      });
   }


   render() {
      const { fields } = this.props;
      return (
         <div>
            <Table>
               <thead>
               <tr>
                  <th>InvItmId</th>
                  <th>Item Name</th>
                  <th>Unit</th>
                  <th>P.Price</th>
                  <th>Return Unit</th>
               </tr>
               </thead>
               <tbody>
               {fields.map((item, index) =>
                  <tr key={index} >
                     <td className="col-md-1" >
                        <Field
                           disabled
                           name={`${item}.item_id`}
                           type="hidden"
                           component="input" />
                        <Field
                           disabled
                           name={`${item}.id`}
                           type="number"
                           component={RenderField} />
                     </td>
                     <td className="col-md-7" >
                        <Field
                           disabled
                           name={`${item}.name`}
                           type="text"
                           component={RenderField} />
                     </td>
                     <td className="col-md-1" >
                        <Field
                           disabled
                           name={`${item}.unit`}
                           type="number"
                           component={RenderField} />
                     </td>
                     <td className="col-md-2" >
                        <Field
                           disabled
                           name={`${item}.price`}
                           type="number"
                           component={RenderField} />
                     </td>
                     <td className="col-md-1" >
                        <Field
                           name={`${item}.return_unit`}
                           type="number"
                           component={RenderField} />
                     </td>
                  </tr>
               )}
               </tbody>
            </Table>
         </div>
      );
   }
}

RenderLists.propTypes = {
   fields: PropTypes.object,
   items: PropTypes.array
};

export default RenderLists;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/SaleReturn/Helper/RenderLists.js
 **/